<template>
<div style="width:100%; margin: 0 auto; height: auto; position: relative">

<nav   style="background-color:#007ea7; text-align:center" v-if="results.length>0&&type=='across'">
                      
                        <ul  style="display: inline-block;margin:4px;padding:0; " v-for="(row,i) in results" :key="i">
                      
                            <!-- does it have a badge or label colour -->
                        
                            <template v-if="$store.state.wasSSR">

                                <a  v-if="row.MenuLevel != 0" class="qsmallfont qwhitelink qfeaturespacing" :href="row.URL">{{ row.Title }}</a>
                            </template>

                            <template v-else>
                            <template v-if="row.MenuLevel != 2"> 
                            <router-link :to="({name: row.RouterLink, params:{param1: row.ParamValue}})" class="qsmallfont " >
                         
                                <li v-if="row.Colour!=null"  class="qsmallfontplus1 qfeaturespacing qwhitelink"  ><span  :style="[{backgroundColor: row.Colour}]" style="padding:3px">{{ langConv(siteName(row.Title))}}</span>
                                    <span if="row.Title=='Free Bets'" class="badge alert" data-nosnippet>{{ $store.state.nopromo }}</span>
                                    <span  :class="{tooltip: hints}" data-nosnippet v-if="row.Description != ''">
                                    <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]" v-html="langConv(row.Description)"></span>
                                    </span>
                                </li> 

                                <li v-else-if="row.Title=='OG Bets'" class="dropdown qsmallfontplus1 qfeaturespacing qwhitetext"  @mouseover="enableMenu('ogbets')" @mouseleave="disableMenu('ogbets')" > {{ langConv(siteName(ogbetstitle))}}
                                    
                                    <span  :class="{tooltip: hints}" data-nosnippet v-if="row.Description != ''">
                                        <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]" v-html="langConv('Our own Bets')"></span>
                                    </span>
                                    <div  id="ogbets" class="dropdown-content-center qsmallfontplus1" style="background-color:#007ea7; text-align:center">
                                       
                                        <router-link class="qwhitelink" :to="({name: 'graph'})">
                                            <div class="qsmallfontplus1" style="padding:5px"> {{ langConv(siteName('Past Bets')) }}
                                                <span  :class="{tooltip: hints}" data-nosnippet>
                                                <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]" v-html="langConv('The bets and users have placed by strategy')"></span>
                                                </span>
                                            </div>
                                        </router-link>  
                                        
                                        <router-link class="qwhitelink" :to="({name: 'pendingbets'})">    
                                        <li  class="qsmallfontplus1 qwhitelink"> {{ langConv(siteName('Current Bets'))}}
                                            <span  :class="{tooltip: hints}" data-nosnippet>
                                            <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]" v-html="langConv('Bets waiting on events that are awaiting to happen. These are our bets not tips')"></span>
                                            </span>
                                        </li>
                                        </router-link> 
                                    
                                    </div>
                                </li>

                                <li v-else-if="row.Title=='Betting Tools'" class="dropdown qsmallfontplus1 qfeaturespacing qwhitetext" @mouseover="enableMenu('ogcalc')" @mouseleave="disableMenu('ogcalc')" > {{ langConv(siteName(bettingtoolstitle))}}
                                    
                                    <span :class="{tooltip: hints}" data-nosnippet v-if="row.Description != ''">
                                        <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]"  v-html="langConv('Betting tools menu')"></span>
                                    </span>
                                    <div  id="ogcalc" class="dropdown-content-center  qsmallfontplus1" style="background-color:#007ea7">
                                        <router-link :to="({name: 'hutchdutchcalc'})" class="qsmallfont qwhitelink ">
                                            <div  class="qsmallfontplus1" style="padding:5px"> {{ langConv(siteName('Betting Calculator')) }}
                                                <span  :class="{tooltip: hints}" data-nosnippet>
                                                <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]" v-html="langConv('Calculator to help you keep track of the odds')"></span>
                                                </span>
                                            </div>
                                        </router-link>      
                                        
                                    </div>
                                </li>



                                <li v-else  class="qsmallfontplus1 qfeaturespacing qwhitelink"  ><span style="padding:3px" :style="[{backgroundColor: row.Colour}]">{{ langConv(siteName(row.Title))}}</span>
                                  
                                    <span  :class="{tooltip: hints}" data-nosnippet>
                                    <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]"  v-html="langConv(row.Description)"></span>
                                    </span>
                                </li>     


                            </router-link>
                            </template>
                            </template>
                        </ul>
                              

</nav>
<nav class="grid-x grid-padding-x grid-padding-y qbordercolour"  v-if="results.length>0&&type=='down'&&!$store.state.wasSSR" >

            <ul  class="dropdown-content-left qbordercolour qsmallfontplus1"  >

                    <li v-for="(row,i) in results" :key="i">
                        <template v-if="row.MenuLevel != 0">
                            <!-- does it have a badge or label colour -->

                            <router-link class="qbuttonhover" @click.native="click(false)" :to="({name: row.RouterLink, params:{param1: row.param1}})">

                                <div v-if="row.Colour!=null" class="label" :style="[{backgroundColor: row.Colour}]">{{langConv(row.Title)}}</div>
                                <div v-else class="qwhitetext">{{ langConv(siteName(row.Title))}} 
                                <span  :class="{tooltip: hints}" >
                                    <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]">{{langConv(row.Description)}}</span>
                                </span> </div>
                                <div v-if="row.Title=='Free Bets'" class="badge alert" data-nosnippet>{{$store.state.nopromo}}</div>

                            </router-link>
                        </template>

                    </li>
            </ul>
</nav>

<nav style="background-color:#007ea7; text-align:center" v-if="results.length>0&&type=='bottom'">
    
          <div class="grid-x qwhitelink"  >

                           <template v-if="$store.state.wasSSR">
                                <a  v-if="row2.MenuLevel != 0" class="qsmallfont qwhitelink " :href="row2.URL">{{ row2.Title }}</a>
                            </template> 
                         
                            <!-- {{  row2.Title }} -->
                            <div class="cell auto text-center" v-for="(row2,i) in bottomMenu" :key="i" >
                            <div  v-if="i===0">
                                   <router-link :to="({name: 'home', params:{}})" class="qsmallfont qwhitelink" >
                                           <div style="height:20px"><img style="height:22x;width:22px" src="/assets/icons/home.png"/></div>
                                           <span :style="[{backgroundColor: row2.Colour}]"> {{ langConv('Home')}}</span>
                                            <span  :class="{tooltip: hints}" data-nosnippet>
                                            <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]"  v-html="langConv(row2.Description)"></span>
                                            </span>         
                                   </router-link>  
                            </div>
                            <div  v-if="row2.Title==='Free Bets' && row2.Colour!=null">
                                <router-link :to="({name: 'offers', params:{}})" class="qsmallfont qwhitelink" >
                                    <div style="height:20px"><img class="qwhiteicon" style="height:23px;width:26px" src="/assets/icons/regular-promos.png"/></div>
                                    <span  :style="[{backgroundColor: row2.Colour}]">{{ langConv(siteName(row2.Title))}}</span>
                                    <span  class="badge alert" data-nosnippet>{{ $store.state.nopromo }}</span>
                                    <span  :class="{tooltip: hints}" data-nosnippet v-if="row2.Description != ''">
                                    <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]" v-html="langConv(row2.Description)"></span>
                                   </span>
                                  </router-link> 
                            </div>    
                           
                            <div v-if="row2.Title==='Bet Finder'"   >
                                <router-link :to="({name: 'betfinder', params:{}})" class="qsmallfont qwhitelink" >
                                <div style="height:20px"><img class="qwhiteicon" style="height:22px;width:22px" src="/assets/icons/betfinder.png"/></div>    
                                <span  :style="[{backgroundColor: row2.Colour}]">{{ langConv(siteName(row2.Title))}}</span>  
                                <span  :class="{tooltip: hints}" data-nosnippet>
                                <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]"  v-html="langConv(row2.Description)"></span>
                                </span>
                                </router-link>
                            </div>    
                          
                            <div v-if="row2.Title==='OG Bets'">
                                                   <router-link class="qsmallfont qwhitelink" :to="({name: 'pendingbets'})"> 
                                                       <div style="height:20px"><img  style="height:22px;width:22px" src="/assets/icons/bet-whi.png"/></div>
                                                        {{ langConv(siteName('OG Bets'))}}
                                                        <span  :class="{tooltip: hints}" data-nosnippet>
                                                        <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]" v-html="langConv(row2.Description)"></span>
                                                        </span>
                                                    </router-link>        
                            </div> 
                            <div v-if="row2.Title==='Betting Calculator'">
                                                   <router-link class="qsmallfont qwhitelink" :to="({name: 'hutchdutchcalc'})">
                                                        <div style="height:20px"><img class="qwhiteicon" style="height:22px;width:22px" src="/assets/icons/betcalc.png"/></div>
                                                        {{ langConv(siteName('Bet Calc'))}}
                                                        <span  :class="{tooltip: hints}" data-nosnippet>
                                                        <span class="tooltiptext" :class="[{'tooltip-right': i < (results.length / 2)}]" v-html="langConv(row2.Description)"></span>
                                                        </span>
                                                    </router-link>        
                            </div> 
                            </div>
                      
            </div>       
</nav>


</div>


</template>

<script>
//import { NULL } from 'node-sass';

    export default {
        name: "features",
        data() {
            return {

                results: [],
                ogbetstitle: 'OG Bets ▼',
                bettingtoolstitle: 'Betting Tools ▼'
            }

        },



        props: {
            type: {type: String, default: 'across'}
        },
        created() {
            if (this.$store.state.wasSSR) {
                this.results = this.$store.state.features
            } else {
               if (this.results.length == 0) {
                    this.GetData();
               }
                   
               
            }
             

        },
        computed: {
            hints () {
                return this.$store.state.showhints;
            },

            bottomMenu() {
                return this.results.filter((row, i) =>
                    i === 0 ||
                    row.Title === 'Free Bets' ||
                    row.Title === 'Bet Finder' ||
                    row.Title === 'OG Bets' ||
                    row.Title === 'Betting Calculator'
                );

            }
        },

        methods: {

            enableMenu: function (val) {

                if (this.$store.state.wasSSR) {
                if (val=='ogbets' ) {
                    document.getElementById(val).style.display = "block";
                    this.ogbetstitle = 'OG Bets ▲'
                }
                
                if (val=='ogcalc' ) {
                    document.getElementById(val).style.display = "block";
                    this.bettingtoolstitle = 'Betting Tools ▲'
                }   
               }
            },

            disableMenu: function(val) {
                if (this.$store.state.wasSSR) {
                if (val=='ogbets') {
                 document.getElementById(val).style.display = "none";
                 this.ogbetstitle = 'OG Bets ▼'
                }
                if (val=='ogcalc') {
                 document.getElementById(val).style.display = "none";
                 this.bettingtoolstitle= 'Betting Tools ▼'
                }
            }
            },

            click: function(val) {

                 if (val == false && this.$store.state.wasSSR) {
                     document.getElementById("menudown").style.display = "none"
                }
    

            },

            GetData: function() {



                this.localJSONLoad(process.env.VUE_APP_DATA + "featuresacross.json").then(response => {
                  
                     this.results= response
               
                });

            }
        }
    }
</script>

<style scoped>

.badge {
    position: relative;
    left: -5px;
    top: -10px;
    font-size:0.6em;
}


</style>